export const highlight = {
  title: 'Highlights'
};

// We define the main version here, which is referenced throughout the app.
export const APP_VERSION = '2.8';

// Keep this derived from APP_VERSION.
export const APP_TITLE = `Ombak (v${APP_VERSION})`;

export const CONSTANTS: any = {
  LOCATION_ACRONYM_TO_FULL_FORM_MAP: {},
  LOCATION_FULL_FORM_TO_ACRONYM_MAP: {},
  INTERVALS: {},
  DEPTH_ACRONYM_TO_FULL_FORM_MAP: {},
  DEPTH_FULL_FORM_TO_ACRONYM_MAP: {}
};
